import Image from 'next/image';
import { useEffect, useState } from 'react';
import { MOBILE_BREAKPOINT } from '../../../constants/componentStaticData';
import { useViewport } from '../../hooks';
import {
  DropdownComponent,
  TDropdownElement,
} from '../DynamicHeader/Dropdown/DropdownComponent';
import { MORE_OPTION } from '../DynamicHeader/Dropdown/DropdownData';
import {
  OldProductDropDown,
  SingleDropDown,
} from '../DynamicHeader/Dropdown/DropdownOptionsComponent';
import { HamburgerMenu } from '../HamburgerMenu';

const myLoader = () => {
  return `https://assets1.cleartax-cdn.com/cleartax/images/1665038118_clearlogo1.svg`;
};
const DefaultNavBar = (): JSX.Element => {
  const [windowWidth, setWidth] = useState(1024);
  const [active, setActive] = useState(false);

  const { width } = useViewport();

  const handleClick = () => {
    setActive(!active);
  };

  useEffect(() => {
    const { innerWidth: widthSize } = window;
    setWidth(widthSize);
  }, [width]);

  return (
    <div className="bg-white" data-testid="Header">
      <div className="bg-white p-3 w-full fixed top-0 z-20 font-medium sm:px-0">
        <nav className="flex items-center flex-wrap z-20 md:w-full sm:w-full font-medium wg-container">
          <a href="/" className="inline-flex items-center p-2 mr-4 ">
            <Image
              loader={myLoader}
              src="me.png"
              alt="Picture of the author"
              width={153}
              height={27}
            />
          </a>
          <DropdownComponent
            dropdownLabel="Products"
            Dropdown={OldProductDropDown}
            classes="px-3 sm:hidden sm:p-0"
          />
          <HamburgerMenu handleMenuClick={handleClick} isOpen={active} />

          <div
            className={`hidden ${
              windowWidth < MOBILE_BREAKPOINT
                ? active
                  ? 'sm:block'
                  : ''
                : ' md:block lg:block xl:block'
            }  sm:w-full bg-white inline-flex flex-grow w-auto z-50
            flex-row-reverse sm:flex-row sm:shadow-sm`}
          >
            <div className="w-full justify-end lg:inline-flex lg:flex-row lg:ml-auto  lg:items-center items-start flex sm:flex-col lg:h-auto xl:h-auto">
              <DropdownComponent
                dropdownLabel="More"
                Dropdown={
                  SingleDropDown as unknown as React.ElementType<TDropdownElement>
                }
                dropdownData={MORE_OPTION}
                classes="px-3  sm:p-0 relative  sm:w-full"
              />

              <div className="px-3 sm:px-0 sm:py-2">
                <a
                  href="https://www.clear.in/s/contact-us"
                  className="inline-flex lg:w-auto w-full px-3 py-2 rounded text-grey-850   items-center justify-center "
                >
                  Support
                </a>
              </div>
            </div>
          </div>
        </nav>
      </div>
      <div className="h-20 sm:h-16"></div>
    </div>
  );
};

export { DefaultNavBar };
